import './rvp'
import Tooltip from '../tooltip';
import baseAssetsModule from './module'

const mqMobile = window.matchMedia('(max-width: 740px)');
const isMobile = mqMobile.matches;

const lazyLoadFooterImages = () => {
    $('img.js_certificate[data-src]').each((index, image) => {
        image.src = $(image).data('src');
    });
    $(window).off("scroll");
};

const attachProductCartClickEvent = () => {
    const $product = $('.js_product-card');

    $product.each((i, item) => {
        const $item = $(item);
        const $feature = $item.find('.js_product-feature');
        const url = $item.data().commonurl || $item.data().url;

        if ($feature.length) {
            $feature.click(event => {
                event.stopPropagation();
            })
        }

        $item.click(() => {
            window.location.href = url;
        })
    })
}

const tooltipActions = (item, method) => {
    item[`${method}`]('tooltip-parent');
    item.find('.custom-tooltip')[`${method}`]('is-active');
}

const toggleShowCustomTooltip = () => {
    const $tooltip = $('.js_has-tooltip');

    $tooltip.hover(
        function() {
            tooltipActions($(this), 'addClass');
        },
        function() {
            tooltipActions($(this), 'removeClass');
        }
    );
}

const attachContactStyles = () => {
    const $hero = $('.js_hero');
    const $contentContainer = $('.js_content-container');

    if (window.location.pathname === '/contact' && window.outerWidth > 1260) {
        $contentContainer.addClass('hero__large');

        const appendedItem = $hero.clone().appendTo('.js_customer-service-container');

        appendedItem.find('.text').addClass('hero__text');
        appendedItem.find('.image').addClass('hero__image');
        $hero.remove();
    }
}

const attachFromAppPaymentStyles = () => {
    if (window.location.href.includes('displaycreditcardmobile')) {
        $('.js_selection-container').addClass('reset-border');
    }

    if (window.location.href.includes('bancontactpayment') && isMobile) {
        $('.js_adyen-checkout-footer').addClass('payment-bancontact-container').find('.js_prev-step').remove();
        $('.js_adyen-navigation').toggleClass('hidden');
    }
}

export default module;

$(document).ready(() => {
    const $footer = $('.js_footer');
    const footerHeight = $footer.outerHeight();
    const windowHeight = $(window).height();

    attachContactStyles();
    attachFromAppPaymentStyles();
    attachProductCartClickEvent();

    baseAssetsModule.checkBreadcrumbsVisibility(window.requestData);

    const isFooterVisibleInViewport = (preloadHeight) => {
        const scrollPosition = $(window).scrollTop();
        const footerTop = $(document).height() - (preloadHeight ? footerHeight + preloadHeight : footerHeight);
        const footerVisibleHeight = Math.max(0, (scrollPosition + windowHeight) - footerTop);

        return footerVisibleHeight > 0;
    };

    const checkAndLoadFooter = () => {
        if (isFooterVisibleInViewport(50)) {
            $footer.removeClass('footer-initialization');
            lazyLoadFooterImages();
            $(window).off('scroll');
        }
    };

    if (isFooterVisibleInViewport()) {
        lazyLoadFooterImages();
    } else {
        $footer.addClass('footer-initialization');
    }

    $(window).scroll(() => {
        checkAndLoadFooter();
    });

    (new Tooltip()).init();

    if (window.location.href.includes('/404')) {
        $('.js_stock-top-message').addClass('hidden');
    }

    toggleShowCustomTooltip();
});
